<template lang='pug'>
  div
    the-mask.input(
      v-if="type === 'cep'"
      v-model.lazy="valueInput"
      type="tel"
      :id="id"
      :disabled="disabled"
      :name="name"
      :value="valueInput"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :mask="['#####-###']"
      @input="onInput($event)"
      @focus="onFocus($event.target.value)"
    )
    the-mask.input(
      v-else-if="type === 'mask'"
      v-model.lazy="valueInput"
      :id="id"
      :disabled="disabled"
      :name="name"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :value="valueInput"
      :mask="mask"
      :tokens="tokens"
      @input="onInput($event)"
      @focus="onFocus($event.target.value)"
    )
    fieldset.inputFake(
      v-else-if="type === 'inputFake'"
      :class="[{ 'inputFake__placeholder': !valueInput }]"
      :disabled="disabled"
      :id="id"
      :name="name"
       @click.prevent="onClick"
    ) {{ valueInput || placeholder }}
    input.input(
      v-else
      v-model.lazy="valueInput"
      :id="id"
      :disabled="disabled"
      :type="type"
      :name="name"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :value="valueInput"
      @input="onInput($event.target.value)"
      @focus="onFocus($event.target.value)"
    )
</template>

<script>
export default {
  name: 'Input',
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => value.match(/(text|number|password|email|mask|money|cep|tel|checkbox|radio|inputFake)/)
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    mask: {
      default: ''
    },
    tokens: {
      type: Object,
      default: () => {
        return {
          '#': { pattern: /\d/ },
          '!': { escape: true }
        }
      }
    },
    maxlength: {
      type: [String, Number],
      default: null
    },
    onClick: {
      type: Function
    }
  },
  data () {
    return {
      valueInput: this.value,
      filled: false,
      vMoneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        allowBlank: true
      }
    }
  },
  watch: {
    value (oldValue, newValue) {
      if (oldValue !== newValue) {
        this.valueInput = oldValue
        this.onInput(this.valueInput)
      }
    }
  },
  created () {
    if (this.value) this.filled = true
  },
  updated () {
    if (this.value) this.filled = true
  },
  methods: {
    onInput (value) {
      if (typeof value === 'string') {
        value = value.trim()
      } else if (typeof value === 'number' && value === 0) {
        return
      }
      (value !== '') ? this.filled = true : this.filled = false
      this.$emit('onChange', value)
    },
    onFocus (value) {
      this.$emit('focus', value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/style/ui/variables";
@import "~@/style/components/_input";
</style>
